import { Global, css } from '@emotion/react';
import { useThemeContext } from '../contexts/ThemeContext';

const GlobalStyles = () => {
  const { theme } = useThemeContext();

  const globalStyles = css`
  * {
    margin: 0;
    padding: 0;
    font-family: Poppins, sans-serif;
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
    color: ${theme.palette.text.primary};
  }

  .MuiAutocomplete-popper {
    z-index: 99999 !important;
  }
`;

  return <Global styles={globalStyles} />
};

export default GlobalStyles;